import React, { useState } from "react";
import { StateDispatchProps } from "../components/state-dispatch.props";
import { QqKeyInfoItemControlGroup } from "../model/qq-key-info-item.model";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Link } from "@mui/material";
import Typography from "@mui/material/Typography";
import Collapse from "@mui/material/Collapse";
import { useStyles } from "../utils/styles.hook";
import { QqResControlFactory } from "./qq-res-control.factory";

export type QqResGroupControlProps = StateDispatchProps &
  QqKeyInfoItemControlGroup;

export const QqResGroupControl: React.FunctionComponent<QqResGroupControlProps> =
  ({ title, controls, state, dispatch }) => {
    const classes = useStyles();
    const [visible, setVisible] = useState(false);

    const controlsFactory = new QqResControlFactory();

    const items = controls.map((c: any, index: number) =>
      controlsFactory.createControl(c, { state, dispatch }, index)
    );

    return (
      <React.Fragment>
        {!visible && (
          <Link underline={"none"} onClick={() => setVisible(!visible)}>
            <Typography
              variant={"body2"}
              className={`${classes.wrapIcon} ${classes.cursorPointer}`}
            >
              {!visible ? (
                <ExpandMore fontSize={"small"} />
              ) : (
                <ExpandLess fontSize={"small"} />
              )}
              {title}
            </Typography>
          </Link>
        )}
        <Collapse in={visible} timeout="auto">
          {items}
          <Link underline={"none"} onClick={() => setVisible(false)}>
            <Typography
              className={`${classes.wrapIcon} ${classes.cursorPointer}`}
              variant={"body2"}
            >
              <ExpandLess fontSize={"small"} />
              Less
            </Typography>
          </Link>
        </Collapse>
      </React.Fragment>
    );
  };
